import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { TileType } from '@swf/core/types/Poker';
import {
  GameTileSection,
  Loader,
  NoData,
  getUpcomingTournaments,
  useGetScheduledTourn,
  useHomeGamesWidget,
  useMapGameData
} from '@swf/poker';

import NoDataIcon from '../../Tournaments/assets/no-data.svg';
import filterRegisteredTournaments from '../../Tournaments/utils/filterRegisteredTournaments';
import type { Props } from '../Container';

import {
  TXTCLI_Cash_Games,
  TXTCLI_Recent_Club_Tournaments,
  TXTCLI_Registered_In_Tournaments,
  TXTCLI_Scheduled_Tournaments,
  TXTWCL_No_Cash_Games_to_Show,
  TXTWCL_No_Tournaments_to_Show
} from './Lobby.messages.json';
import styles from './Lobby.scss';

const Lobby: React.FC<Props> = (props) => {
  const clubId = Number(props.match.params.clubId);
  const { widgetSelect } = useHomeGamesWidget();
  const clubs = useSelector(widgetSelect.clubs);
  const { scheduled, loadingScheduled } = useGetScheduledTourn({ clubs, clubId });
  const loading = props.loading || loadingScheduled;

  const { mappedTables, mappedTournaments, mappedRecentTournaments } = useMapGameData({
    shouldMapTables: true,
    shouldMapTournaments: true
  });

  const filteredTournaments = filterRegisteredTournaments({
    tournaments: mappedTournaments,
    scheduled
  });
  const upcomingTournaments = getUpcomingTournaments(mappedTournaments[clubId], scheduled);
  const showUpcoming = !isEmpty(upcomingTournaments);
  const showScheduled = !isEmpty(filteredTournaments[clubId]);
  const showTables = !isEmpty(mappedTables[clubId]);
  const showUnavailable = !isEmpty(mappedRecentTournaments[clubId]);

  return (
    <div
      className={classNames(styles.container, {
        [styles.loading]: loading
      })}
    >
      <Loader loading={loading}>
        {showUpcoming && (
          <GameTileSection
            title={<Translation {...TXTCLI_Registered_In_Tournaments} />}
            games={upcomingTournaments}
            type={TileType.Scheduled}
          />
        )}
        {showScheduled && (
          <GameTileSection
            title={<Translation {...TXTCLI_Scheduled_Tournaments} />}
            games={filteredTournaments[clubId]}
            type={TileType.Upcoming}
          />
        )}
        {showTables && (
          <GameTileSection
            title={<Translation {...TXTCLI_Cash_Games} />}
            games={mappedTables[clubId]}
            type={TileType.Cash}
          />
        )}
        {showUnavailable && (
          <GameTileSection
            games={mappedRecentTournaments[clubId]}
            title={<Translation {...TXTCLI_Recent_Club_Tournaments} />}
            type={TileType.Recent}
          />
        )}
        {!showUpcoming && !showScheduled && !showTables && !showUnavailable && (
          <NoData
            icon={<NoDataIcon />}
            primaryText={<Translation {...TXTWCL_No_Tournaments_to_Show} />}
            secondaryText={
              <>
                <span>& </span>
                <Translation {...TXTWCL_No_Cash_Games_to_Show} />
              </>
            }
          />
        )}
      </Loader>
    </div>
  );
};

export default Lobby;
